import classNames from 'classnames';

import './IconCircled.scss';

export const ICON_CIRCLE_SIZE = {
  EXTRA_SMALL: 'extra-small',
  SMALL: 'small',
  MEDIUM: 'medium',
  MEDIUM_LARGE: 'medium-large',
  LARGE: 'large',
};

const IconCircled = ({
  className,
  size = ICON_CIRCLE_SIZE.SMALL,
  icon,
  backgroundColor,
  borderColor,
  isWhiteLogo,
}) => (
  <div
    className={classNames('IconCircled', size, className, {
      'with-border': borderColor,
      'white-logo': isWhiteLogo,
    })}
    style={{
      backgroundColor,
      borderColor,
    }}
  >
    {icon}
  </div>
);

export default IconCircled;
